import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedReembolsosAgregarComponent {
  idColaborador
  idProyecto
  data = {
    importe: 0,
  }
  dataOriginal
  onClose
  solicitando = false
  viaticoId

  constructor ($q, ViaticosSolicitudReembolsoService) {
    this.$q = $q
    this.ViaticosSolicitudReembolsoService = ViaticosSolicitudReembolsoService
  }

  $onInit () {
    this.dataOriginal = Object.assign({}, this.data)
    this.data = {importe: this.data.saldo}
  }

  solicitar () {
    this.solicitando = true
    this.ViaticosSolicitudReembolsoService.post(this.idProyecto, this.idColaborador, this.data, this.viaticoId)
      .then(({data}) => this.onClose({$event: {detail: data}}))
      .finally(() => this.solicitando = false)
  }

  cerrar () {
    this.onClose({$event: {detail: null}})
  }
}

module.component('viaticosSharedReembolsosAgregar', {
  controller: ViaticosSharedReembolsosAgregarComponent,
  template,
  bindings: {
    idColaborador: '<',
    idProyecto: '<',
    data: '<',
    viaticoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/reembolsos/agregar/component.js